import axios from "axios";
import toast from "react-hot-toast";

// Base configuration
// Ưu tiên: env variable > localStorage > default (production)
const getBaseURL = () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL;
  }
  const savedDomain = localStorage.getItem("api-base-url");
  if (savedDomain) {
    return savedDomain;
  }
  // Mặc định là production
  const defaultDomain = "https://bedev.trove.id.vn/api";
  localStorage.setItem("api-base-url", defaultDomain);
  localStorage.setItem("api-domain-preference", "production");
  return defaultDomain;
};

// Create axios instance với baseURL mặc định
const apiClient = axios.create({
  baseURL: getBaseURL(),
  headers: {
    "Content-Type": "application/json",
  },
});

apiClient.interceptors.request.use(
  (config) => {
    // Cập nhật baseURL động từ localStorage mỗi request
    const dynamicBaseURL = getBaseURL();
    if (config.baseURL !== dynamicBaseURL) {
      config.baseURL = dynamicBaseURL;
    }

    const token = localStorage.getItem("admin-storage");
    if (token) {
      try {
        const parsedToken = JSON.parse(token);
        if (parsedToken.state?.token) {
          config.headers.Authorization = `Bearer ${parsedToken.state.token}`;
          config.headers["xtc-admin-token"] = parsedToken.state?.token;
        }
      } catch (error) {
        console.log("Error parsing token:", error);
      }
    }

    // Log request in development
    if (process.env.NODE_ENV === "development") {
      console.log("API Request:", {
        method: config.method?.toUpperCase(),
        url: config.url,
        baseURL: config.baseURL,
        data: config.data,
        headers: config.headers,
      });
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor
apiClient.interceptors.response.use(
  (response) => {
    // Log response in development
    if (process.env.NODE_ENV === "development") {
      console.log("API Response:", {
        status: response.status,
        url: response.config.url,
        data: response.data,
      });
    }

    return response;
  },
  (error) => {
    const { response } = error;

    // Log error in development
    if (process.env.NODE_ENV === "development") {
      console.log("API Error:", {
        status: response?.status,
        url: error.config?.url,
        message: error.message,
        data: response?.data,
      });
    }

    // Handle different error status codes
    if (response) {
      switch (response.status) {
        case 401:
          if (response.data.msg_code === "WRONG_ACCOUNT_OR_PASSWORD") {
            return;
          } else {
            // Check if we're on a public route - don't redirect if so
            const currentPath = window.location.pathname;
            const publicRoutes = ["/", "/home"];
            const isPublicRoute = publicRoutes.includes(currentPath);

            if (!isPublicRoute) {
              toast.error("Unauthorized. Please login again.");
              localStorage.removeItem("admin-storage");
              window.location.href = "/admin/login";
            }
            // If on public route, just reject the error without redirecting
          }

          break;
        case 403:
          toast.error("Access denied. You do not have permission.");
          break;
        case 404:
          toast.error("Resource not found.");
          break;
        case 422:
          toast.error(response.data?.message || "Validation error.");
          break;
        case 500:
          toast.error("Server error. Please try again later.");
          break;
        default:
          toast.error(response.data?.message || "An error occurred.");
      }
    } else {
      toast.error("Network error. Please check your connection.");
    }

    return Promise.reject(error);
  }
);

export default apiClient;
